import Vue from 'vue'
import store from '@/store/store.js'

export default {

  dd: {},

  async makeDocDefinition (signature, content, header, footer, cb) {
    let headerImage = null;
    let footerImage = null;
    if (header) {
      headerImage = await store.dispatch('getFileAsDataUrl', header)
    }
    if (footer) {
      footerImage = await store.dispatch('getFileAsDataUrl', footer)
    }
    this.dd = {
      content: [{
        "columns": [],
        "style": "font-sm"
      }, { "text": [{ "text": "" }] }],
      defaultStyle: {
        "font": "english",
      },
      "pageMargins": [
        25,
        120,
        25,
        120
      ],
      "header": {
        "image": "headerImage",
        "width": 600,
        "height": 100
      },
      "footer": {
        "image": "footerImage",
        "width": 600,
        "height": 100
      },
      "images": {
        "headerImage": headerImage,
        "footerImage": footerImage
      },
      "styles": {
        "break": {
          "margin": [0, 20]
        }
      }
    };
    if (content && content.ops && content.ops.length > 0) {
      for (let delta of content.ops) {

        let data = {};
        let type = "";
        let listItem = null;
        if (delta.insert) {
          if (typeof delta.insert === 'string') {
            data['text'] = delta.insert;
            type = 'text';
          } else if (typeof delta.insert === 'object' && delta.insert["image"]) {
            let url = new URL(delta.insert.image);
            //if it is dataUrl then athis.dding it
            if (url.protocol !== "http:" && url.protocol !== "https:") {
              data['image'] = delta.insert.image;
              data['width'] = 550;
              type = 'image';
              //if it is external url then athis.dding it after converting to dataUrl
            } else if (url.protocol === "http:" || url.protocol === "https:") {
              try {
                let response = (await Vue.http({
                  method: 'GET',
                  url: delta.insert.image,
                  responseType: 'arraybuffer'
                })).data

                if (response) {
                  let uInt8Array = new Uint8Array(response);
                  let i = uInt8Array.length;
                  let biStr = new Array(i);
                  while (i--) {
                    biStr[i] = String.fromCharCode(uInt8Array[i]);
                  }
                  let Bidata = biStr.join('');
                  let base64 = window.btoa(Bidata);
                  let dataUrl = 'data:image/' + "PNG" + ';base64,' + base64;
                  if (dataUrl) {
                    data['image'] = dataUrl;
                    data['width'] = 550;
                    type = 'image';
                  }
                }
              } catch (e) {
                console.log(e)
              }
            }
          }

          if (delta.attributes) {

            if (delta.attributes['header']) {
              if (delta.attributes['header'] == 1) {
                //athis.dding header attributes to previous element
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                  let index = this.dd.content[this.dd.content.length - 1].text.length - 1;
                  this.dd.content[this.dd.content.length - 1].text[index]['fontSize'] = 26 * (72 / 96);
                  this.dd.content[this.dd.content.length - 1].text[index]['bold'] = true;
                }
              }
              if (delta.attributes['header'] == 2) {
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                  let index = this.dd.content[this.dd.content.length - 1].text.length - 1;
                  this.dd.content[this.dd.content.length - 1].text[index]['fontSize'] = 19.5 * (72 / 96);
                  this.dd.content[this.dd.content.length - 1].text[index]['bold'] = true;
                }
              }
              if (delta.attributes['header'] == 3) {
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                  let index = this.dd.content[this.dd.content.length - 1].text.length - 1;
                  this.dd.content[this.dd.content.length - 1].text[index]['fontSize'] = 15.21 * (72 / 96);
                  this.dd.content[this.dd.content.length - 1].text[index]['bold'] = true;
                }
              }
              if (delta.attributes['header'] == 4) {
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                  let index = this.dd.content[this.dd.content.length - 1].text.length - 1;
                  this.dd.content[this.dd.content.length - 1].text[index]['fontSize'] = 13 * (72 / 96);
                  this.dd.content[this.dd.content.length - 1].text[index]['bold'] = true;
                }
              }
              if (delta.attributes['header'] == 5) {
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                  let index = this.dd.content[this.dd.content.length - 1].text.length - 1;
                  this.dd.content[this.dd.content.length - 1].text[index]['fontSize'] = 10.79 * (72 / 96);
                  this.dd.content[this.dd.content.length - 1].text[index]['bold'] = true;
                }
              }
              if (delta.attributes['header'] == 6) {
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                  let index = this.dd.content[this.dd.content.length - 1].text.length - 1;
                  this.dd.content[this.dd.content.length - 1].text[index]['fontSize'] = 8.71 * (72 / 96);
                  this.dd.content[this.dd.content.length - 1].text[index]['bold'] = true;
                }
              }
            }

            if (delta.attributes['size']) {
              if (delta.attributes['size'] == 'large') {
                data['fontSize'] = 19.5 * (72 / 96); //Converting px to pt
              }
              if (delta.attributes['size'] == 'small') {
                data['fontSize'] = 9.75 * (72 / 96); //Converting px to pt
              }
              if (delta.attributes['size'] == 'huge') {
                data['fontSize'] = 32.5 * (72 / 96); //Converting px to pt
              }
            }

            if (delta.attributes['indent']) {
              if (this.dd.content[this.dd.content.length - 1]) {
                if (typeof this.dd.content[this.dd.content.length - 1] === 'object') {
                  let indent = delta.attributes['indent'] * 10;
                  //athis.dding indent attributes to previous element
                  this.dd.content[this.dd.content.length - 1]["margin"] = [indent, 0, 0, 0]
                }
              }
            }

            if (delta.attributes['align']) {
              if (this.dd.content[this.dd.content.length - 1]) {
                if (typeof this.dd.content[this.dd.content.length - 1] === 'object') {
                  //athis.dding align attributes to previous element
                  this.dd.content[this.dd.content.length - 1]["alignment"] = delta.attributes['align']
                }
              }
            }

            if (delta.attributes['list']) {
              listItem = delta.attributes['list'];
            }

            if (delta.attributes['bold']) {
              data['bold'] = true;
            }

            if (delta.attributes['italic']) {
              data['italics'] = true;
            }

            if (delta.attributes['strike']) {
              data['decoration'] = "lineThrough";
            }

            if (delta.attributes['underline']) {
              data['decoration'] = "underline";
            }

            if (delta.attributes['link']) {
              data['link'] = delta.attributes['link'];
            }

            if (delta.attributes['color']) {
              data['color'] = delta.attributes['color'];
            }

            if (delta.attributes['background']) {
              data['background'] = delta.attributes['background'];
            }

          }

          if (listItem === null) {
            if (type == 'text') {
              if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                this.dd.content[this.dd.content.length - 1].text.push(data)
              } else {
                this.dd.content.push({ text: [] })
                this.dd.content[this.dd.content.length - 1].text.push(data)
              }
            } else if (type == 'image') {
              this.dd.content.push(data)
            }
          } else {
            if (listItem == "ordered") {
              if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                //removing last item and athis.dding it to ol array
                let lastPushedItem = this.dd.content[this.dd.content.length - 1].text.pop();
                if (this.dd.content[this.dd.content.length - 1].text.length == 0) {
                  this.dd.content.pop();
                }
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].ol) {
                  this.dd.content[this.dd.content.length - 1].ol.push(lastPushedItem);
                } else {
                  if (lastPushedItem && lastPushedItem.text) {
                    let count = lastPushedItem.text.split(/\n/).length - 1;
                    if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                      for (let i = 0; i < count; i++) {
                        this.dd.content[this.dd.content.length - 1].text.push({ text: "\n" })
                      }
                    } else {
                      this.dd.content.push({ text: [] });
                      for (let i = 0; i < count; i++) {
                        this.dd.content[this.dd.content.length - 1].text.push({ text: "\n" })
                      }
                    }
                    lastPushedItem.text = lastPushedItem.text.replace(/(\n)/gm, "");
                  }
                  this.dd.content.push({ ol: [] });
                  this.dd.content[this.dd.content.length - 1].ol.push(lastPushedItem);
                }
              } else if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].image) {
                let lastPushedItem = this.dd.content.pop();
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].ol) {
                  this.dd.content[this.dd.content.length - 1].ol.push(lastPushedItem);
                } else {
                  this.dd.content.push({ ol: [] });
                  this.dd.content[this.dd.content.length - 1].ol.push(lastPushedItem);
                }
              } else {
                this.dd.content.push({ ol: [] });
                this.dd.content[this.dd.content.length - 1].ol.push(data);
              }

            } else if (listItem == "bullet") {
              if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                //removing last item and athis.dding it to ul array
                let lastPushedItem = this.dd.content[this.dd.content.length - 1].text.pop();
                if (this.dd.content[this.dd.content.length - 1].text.length == 0) {
                  this.dd.content.pop();
                }
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].ul) {
                  this.dd.content[this.dd.content.length - 1].ul.push(lastPushedItem);
                } else {
                  if (lastPushedItem && lastPushedItem.text) {
                    let count = lastPushedItem.text.split(/\n/).length - 1;
                    if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].text) {
                      for (let i = 0; i < count; i++) {
                        this.dd.content[this.dd.content.length - 1].text.push({ text: "\n" })
                      }
                    } else {
                      this.dd.content.push({ text: [] });
                      for (let i = 0; i < count; i++) {
                        this.dd.content[this.dd.content.length - 1].text.push({ text: "\n" })
                      }
                    }
                    lastPushedItem.text = lastPushedItem.text.replace(/(\n)/gm, "");
                  }
                  this.dd.content.push({ ul: [] });
                  this.dd.content[this.dd.content.length - 1].ul.push(lastPushedItem);
                }
              } else if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].image) {
                let lastPushedItem = this.dd.content.pop();
                if (this.dd.content[this.dd.content.length - 1] && this.dd.content[this.dd.content.length - 1].ul) {
                  this.dd.content[this.dd.content.length - 1].ul.push(lastPushedItem);
                } else {
                  this.dd.content.push({ ul: [] });
                  this.dd.content[this.dd.content.length - 1].ul.push(lastPushedItem);
                }
              } else {
                this.dd.content.push({ ul: [] });
                this.dd.content[this.dd.content.length - 1].ul.push(data);
              }

            }
          }

        }
      }
    }
    this.dd.content.push({
      image: signature,
      width: 200,
      height: 100,
      alignment: "right",
      style: "break",
    })
    this.dd.content.push({
      text:
        "___________________________________\n" +
        "Signature",
      bold: true,
      alignment: "right",
    })
    if (!headerImage) {
      delete this.dd["header"]
    }
    if (!footerImage) {
      delete this.dd["footer"]
    }
    cb()
  },

  async getDataURL (signature, content, header, footer, cb) {

    let that = this

    await this.makeDocDefinition(signature, content, header, footer, function () {
      var dataUrlHandle = pdfMake.createPdf(that.dd);

      dataUrlHandle.getDataUrl(function (data) {
        cb(data);
      });
    });

  }

}
